import * as React from "react";

const { Component } = React;

import { createOrSaveIntegration } from "../IntegrationStore";
import { alert } from "../../general/alertStore.js";
import IntegrationTrigger from "../IntegrationTrigger";
import axios from "../../general/HttpClient";
import { GetContext, UnsubscribeContext } from "../../general/ApplicationContext";

import { ScadsysProps, ScadsysUserState, ScadsysIntegration } from "./ScadsysStore";
import { Input, FormGroup, Label } from "../../components/Modal";

let contextSubscriptionId = "";

export default class ImportScadsysUsers extends Component<ScadsysProps, ScadsysUserState> {
    constructor(props) {
        super(props);

        this.state = {
            profiles: [],
            users: [],
            selectedProfile: new ScadsysIntegration(),
            selectedProfileId: "",
            totals: {
                users: 0,
            },
            syncResult: null,
        };
    }

    saveProfile = () => {
        if (this.state.selectedProfile.name) {
            this.setState(
                (prevState) => {
                    prevState.selectedProfile.integrationDirection = 0; //In
                    prevState.selectedProfile.integrationType = 1; //ScadsysUsers
                    prevState.selectedProfile.organizationId = this.props.organization;

                    return prevState;
                },
                () => {
                    createOrSaveIntegration(this.state.selectedProfile).then(() => {
                        this.getProfiles();
                    });
                }
            );
        }
    };

    loadUsers = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/GetScadsysUsers`, this.state.selectedProfile.config).then((response) => {
            this.setState({
                totals: {
                    users: response.data.totalUsers,
                },
                users: response.data.users.map((user) => {
                    return user;
                }),
            });
        });
    };

    importUsers = () => {
        axios
            .post(`/api/Integrations/${this.state.selectedProfileId}/ImportUsersFromScadsys`, this.state.selectedProfile.config)
            .then((response) => {
                alert({
                    type: "alert-success",
                    text: `${response.data.usersProcessed} users processed successfully`,
                });
                this.setState({ syncResult: response.data });
            })
            .catch((response) => {
                this.setState({ syncResult: response.data });
            });
    };

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.getProfiles();
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    getProfiles = () => {
        axios
            .get(`/api/Integrations/Types/1?organizationId=${this.props.organization}`) //Scadsys
            .then((response) => {
                this.setState({ profiles: response.data.filter(i=>i.integrationDirection == 0), selectedProfile: new ScadsysIntegration(), selectedProfileId: "" });
            });
    };

    handleProfileChange = (e) => {
        let id = e.target.value;
        this.setState((prevState) => ({ selectedProfileId: id, selectedProfile: new ScadsysIntegration(prevState.profiles.filter((profile) => profile.integrationId == id)[0]) }));
    };

    handleNameChange = (e) => {
        let name = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.name = name;
            return prevState;
        });
    };

    handlePriorityChange = (e) => {
        let priority = e.target.valueAsNumber;
        this.setState((prevState) => {
            prevState.selectedProfile.priority = priority;
            return prevState;
        });
    };

    handleSchoolIdChange = (e) => {
        let schoolId = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.schoolId = schoolId;
            return prevState;
        });
    };

    handleScadsysUrlChange = (e) => {
        let url = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.url = url;
            return prevState;
        });
    };

    handlePageSizeChange = (e) => {
        let pageSize = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.pageSize = pageSize;
            return prevState;
        });
    };

    handleDomainChange = (e) => {
        let domain = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.domain = domain;
            return prevState;
        });
    };

    render() {
        return (
            <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Scadsys Users Import</h3>

                <div className="space-y-6">
                    <div>
                        <FormGroup>
                            <Label htmlFor="profile">Profile</Label>
                            <Input type="select" id="profile" onChange={this.handleProfileChange} value={this.state.selectedProfileId}>
                                <option>Please Select</option>
                                {this.state.profiles.map((profile) => (
                                    <option key={profile.integrationId} value={profile.integrationId}>
                                        {profile.name}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    </div>
                    
                    {this.state.selectedProfileId && (
                        <div>
                            <IntegrationTrigger integration={this.state.selectedProfile}></IntegrationTrigger>
                        </div>
                    )}
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <FormGroup>
                            <Label htmlFor="profileName">Profile Name</Label>
                            <Input type="text" id="profileName" value={this.state.selectedProfile.name} onChange={this.handleNameChange} />
                        </FormGroup>
                        
                        {this.state.selectedProfileId && (
                            <FormGroup>
                                <Label htmlFor="priority">Priority (lower first)</Label>
                                <Input type="number" id="priority" value={this.state.selectedProfile.priority} onChange={this.handlePriorityChange} />
                            </FormGroup>
                        )}
                        
                        {!this.state.selectedProfileId && (
                            <div className="flex items-end">
                                <button className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors" type="button" onClick={this.saveProfile}>
                                    Create Profile
                                </button>
                            </div>
                        )}
                    </div>
                    
                    {this.state.selectedProfileId && (
                        <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <FormGroup>
                                    <Label htmlFor="schoolId">School ID</Label>
                                    <Input type="text" id="schoolId" value={this.state.selectedProfile.config.schoolId} onChange={this.handleSchoolIdChange} />
                                </FormGroup>
                                
                                <FormGroup>
                                    <Label htmlFor="scadsysUrl">Scadsys URL</Label>
                                    <Input type="text" id="scadsysUrl" value={this.state.selectedProfile.config.url} onChange={this.handleScadsysUrlChange} />
                                </FormGroup>
                                
                                <FormGroup>
                                    <Label htmlFor="domain">Domain</Label>
                                    <Input type="text" id="domain" value={this.state.selectedProfile.config.domain} onChange={this.handleDomainChange} />
                                </FormGroup>
                                
                                <FormGroup>
                                    <Label htmlFor="pageSize">Page Size</Label>
                                    <Input type="number" id="pageSize" value={this.state.selectedProfile.config.pageSize} onChange={this.handlePageSizeChange} />
                                    <p className="text-xs text-gray-500 mt-1">Make this 0 for all, or specify a number to improve performance on large data sets</p>
                                </FormGroup>
                            </div>
                            
                            <div className="flex justify-end">
                                <button className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors" type="button" onClick={this.saveProfile}>
                                    Save Profile
                                </button>
                            </div>
                            
                            <div className="flex justify-end space-x-3">
                                <button className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors" type="button" onClick={this.loadUsers}>
                                    Load
                                </button>
                                <button className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors" type="button" onClick={this.importUsers}>
                                    Import
                                </button>
                            </div>

                            {this.state.syncResult && (
                                <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
                                    <a href={`/hangfire/jobs/details/${this.state.syncResult}`} className="text-blue-600 hover:text-blue-800 underline font-medium">
                                        Background Job Created
                                    </a>
                                </div>
                            )}

                            <div className="overflow-x-auto rounded-lg border border-gray-200">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "20%" }}>User Number</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "40%" }}>Name</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        <tr className="bg-gray-50">
                                            <th className="px-6 py-4 text-sm font-semibold text-gray-900">{this.state.totals.users} Users</th>
                                            <th></th>
                                        </tr>
                                        {this.state.users.map((user, i) => (
                                            <tr key={i} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 text-sm text-gray-900">{user.sourceID}</td>
                                                <td className="px-6 py-4 text-sm text-gray-900">{user.fullName}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
